import React from "react";

const LineProgressBar = ({ indexProgress }) => {
  var width = 30 * indexProgress;

  

  return (
    <div className="statusbar_nr"> 
      <div className="sg-statusbar_nr sg-statusbar-muted_nr"></div>
      <div
        className="sg-statusbar_nr sg-statusbar-progress_nr"
        style={{ width: width + '%'}}
      >
      </div>
    </div>
  );
};

export default LineProgressBar;
